<script lang="ts">import { stateUi } from "@infinitro/config";
import AccordionAlternative2 from "./accordion-alternative2.svelte";
import AccordionDefault from "./accordion-default.svelte";
$: useAlternative2 = $stateUi.accordion?.accordionStyle === "alternative2";
</script>

{#if useAlternative2 || $$props.useAlternative2Design}
	<AccordionAlternative2 {...$$props}>
		<slot name="content" slot="content" />
	</AccordionAlternative2>
{:else}
	<AccordionDefault {...$$props}>
		<slot name="content" slot="content" />
	</AccordionDefault>
{/if}
